import {useNavigate} from 'react-router-dom';

import {APP_ROUTES, BREAKPOINTS} from '../../../const';
import useBreakpoint from '../../../hooks/dom/useBreakpoint';
import useBanner from '../../../hooks/providers/useBanner';
import Button from '../../form/buttons/Button/Button';

const HeaderUpgradeSubscriptionButton = () => {
  const currentBreakpoint = useBreakpoint();

  const navigate = useNavigate();
  const {shouldDisplayTrialInProgressBanner, shouldDisplayTrialExpiredBanner, shouldDisplayExpiredSubscriptionBanner} = useBanner();

  if (!shouldDisplayTrialInProgressBanner && !shouldDisplayTrialExpiredBanner) return null;

  const isSmallScreen = currentBreakpoint === BREAKPOINTS.sm || currentBreakpoint === BREAKPOINTS.xs;

  const fontSize = isSmallScreen ? 10 : 12;
  const buttonSize = isSmallScreen ? 'small' : 'medium';
  const marginLeft = isSmallScreen ? 1 : 2;

  const handleClick = () => {
    navigate(APP_ROUTES.subscription);
  };

  return (
    <Button onClick={handleClick} size={buttonSize} variant="outlined" color="secondary" sx={{ml: marginLeft, fontSize, minWidth: 110, color: 'secondary.main'}}>
      Mettre à niveau
    </Button>
  );
};

export default HeaderUpgradeSubscriptionButton;
